export default __webpack_public_path__ + "static/Entenda0069-5a3e2ab1c95016696376897ecc6830b3.jpg";